import React, { useState, useEffect } from 'react';

function ClockNav({ timezone }) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const options = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    //weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    //second: 'numeric',
    timeZone: timezone // Use the timezone prop here
  };

  const formattedTime = time.toLocaleString('en-US', options);

  return (
    <div
      style={{
        backgroundColor: 'transparent',
        color: '#333',
        textAlign: 'center',
        padding: '10px'
      }}
    >
      <p style={{ fontSize: '13px', margin: '0' }}>
        {formattedTime} ({timezone})
      </p>
    </div>
  );
}

export default ClockNav;
